// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Constants
import { DATE_SELECTION_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
// Actions
import { setFundChartDateSelection } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/date-selection/date-selection.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const dateSelection = createReducer(DATE_SELECTION_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.dateSelection), on(setFundChartDateSelection, (state, { selection }) => selection));
